import { RouterActionTypes } from './router.action.types';
export var SyncRoutes = function (uiRouterCurrentState) { return ({
    type: RouterActionTypes.SYNC_ROUTE,
    payload: uiRouterCurrentState
}); };
//# sourceMappingURL=syncRoutes.action.js.map